import React from 'react';
import { withRouter, Switch } from 'react-router-dom';
import AppRoute from './utils/AppRoute';
import ScrollReveal from './utils/ScrollReveal';


// Layouts
import LayoutDefault from './layouts/LayoutDefault';
import LayoutAlternative from './layouts/LayoutAlternative';
import LayoutSignin from './layouts/LayoutSignin';

// Views 
import Home from './views/Home';
import Secondary from './views/Secondary';
import Login from './views/Login';
import Signup from './views/Signup';
import ForgotPassword from './views/ForgotPassword.js';
import ResetPassword from './views/ResetPassword.js';
import OtpVerfy from './views/OtpVerify.js';
import OcrExtractView from './views/OcrExtractView.js';
import InvoiceSettings from './views/InvoiceSettings';
import InvoiceView from './views/InvoiceView';
import TermsOfService from './views/TermsOfService';
import PrivacyPolicy from './views/PrivacyPolicy';
import SettingsBank from './views/SettingsBank';
import BoxSettings from './views/BoxSettings.js';
import BillingInvoicePage from './components/Billing/BillingInvoicePage';
import OrganizationSettings from './views/OrganizationSettings';
import Support from './views/Support';

import Tutorial from './components/Tutorial';

class App extends React.Component {

  componentDidMount() {
    document.body.classList.add('is-loaded');
    this.refs.scrollReveal.init();
  }

  // Route change
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.refs.scrollReveal.init();
    }
  }

  render() {
    return (
      <ScrollReveal
        ref="scrollReveal"
        children={() => (
          <>
            <Tutorial />
            <Switch>
            <AppRoute
              exact
              path="/"
              component={Home}
              layout={LayoutDefault}
            />
            <AppRoute
              exact
              path="/secondary"
              component={Secondary}
              layout={LayoutAlternative}
              isPrivate        // 👈 needs login
            />
            <AppRoute exact path="/ocr-extract-view" component={OcrExtractView} layout={LayoutDefault} />


            {/* public auth pages */}
            <AppRoute exact path="/login" component={Login} layout={LayoutSignin} />
            <AppRoute exact path="/signup" component={Signup} layout={LayoutSignin} />
            <AppRoute exact path="/forgot-password" component={ForgotPassword} layout={LayoutSignin} />
            <AppRoute exact path="/reset-password" component={ResetPassword} layout={LayoutSignin} />
            <AppRoute exact path="/otp-verify" component={OtpVerfy} layout={LayoutSignin} />
            <AppRoute exact path="/settings/invoice" component={InvoiceSettings} layout={LayoutDefault} invertHeader={false} />
            <AppRoute exact path="/invoice/view" component={InvoiceView} layout={LayoutDefault} isPrivate invertHeader={false} />
            <AppRoute exact path="/settings/bank" component={SettingsBank} layout={LayoutDefault} isPrivate invertHeader={false} />
            <AppRoute exact path="/settings/box" component={BoxSettings} layout={LayoutDefault} isPrivate invertHeader={false} />
            <AppRoute exact path="/settings/organization" component={OrganizationSettings} layout={LayoutDefault} isPrivate invertHeader={false} />
            <AppRoute exact path="/support" component={Support} layout={LayoutDefault} isPrivate invertHeader={false} />

            {/* Legal Pages */}
            <AppRoute exact path="/terms-of-service" component={TermsOfService} layout={LayoutDefault} invertHeader={false} />
            <AppRoute exact path="/privacy-policy" component={PrivacyPolicy} layout={LayoutDefault} invertHeader={false} />
            <AppRoute exact path="/billing/invoice" component={BillingInvoicePage} layout={LayoutDefault} isPrivate invertHeader={false} />
          </Switch>
          </>
        )}
      />
    );
  }
}

export default withRouter(props => <App {...props} />);
